var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7383 1.31641L6.55469 5.5L10.7383 9.68359L9.68359 10.7383L5.5 6.55469L1.31641 10.7383L0.261719 9.68359L4.44531 5.5L0.261719 1.31641L1.31641 0.261719L5.5 4.44531L9.68359 0.261719L10.7383 1.31641Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-close.dce99903.svg";
export { ForwardRef as ReactComponent };